// Today's inquiries, in full — the screen behind the "New inquiries" number.
//
// The Today card could say "7 came in" but never which seven. That made the
// one thing worth acting on — a big-money request that needs parts arranged
// today — indistinguishable from a routine one. Clicking the number now lands
// here: every inquiry of the day, biggest first, with the customer, the parts,
// the salesperson who took it and the supervisor who priced it.

import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../components/layout/MainLayout.jsx';
import { PageHeader } from '../components/common/index.js';
import InquiryDayList from '../components/inquiries/InquiryDayList.jsx';
import { ROUTES } from '../constants/app.constants';
import { FiUserPlus, FiArrowLeft } from 'react-icons/fi';

const PERIODS = [
  { id: 'today', label: 'Today' },
  { id: 'yesterday', label: 'Yesterday' },
  { id: 'week', label: 'Last 7 days' },
  { id: 'month', label: 'This month' },
];

const TodayInquiriesPage = () => {
  const [period, setPeriod] = React.useState('today');

  return (
    <MainLayout>
      <PageHeader
        icon={FiUserPlus}
        title="Inquiries that came in"
        purpose="Every request the team took, biggest money first — so the deals worth chasing, and the parts they need, are the first thing you see."
      >
        <Link
          to={ROUTES.TODAY}
          className="inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-3.5 py-2 text-sm font-semibold text-slate-600 transition-all hover:bg-slate-50"
        >
          <FiArrowLeft className="h-4 w-4" /> Back to Today
        </Link>
      </PageHeader>

      <div className="mb-4 inline-flex flex-wrap gap-1 rounded-xl border border-slate-200 bg-white p-1">
        {PERIODS.map((p) => (
          <button
            key={p.id}
            type="button"
            onClick={() => setPeriod(p.id)}
            className={`rounded-lg px-3.5 py-1.5 text-xs font-bold transition-all ${
              period === p.id ? 'bg-violet-600 text-white' : 'text-slate-500 hover:text-slate-700'
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>

      <InquiryDayList period={period} pageSize={25} />
    </MainLayout>
  );
};

export default TodayInquiriesPage;
